import { RagChatComponent } from '../components/rag-chat/rag-chat.component';
import { RagChatService } from '../service/rag-chat.service';
import {
  ApplicationRef,
  EnvironmentInjector,
  createComponent,
} from '@angular/core';
import { AuthEvent, AuthService, ConfigService } from '@openmfp/portal-ui-lib';
import { filter, take } from 'rxjs';

export function initRagChat(
  authService: AuthService,
  configService: ConfigService,
  ragChatService: RagChatService,
  appRef: ApplicationRef,
  injector: EnvironmentInjector,
) {
  return async (): Promise<void> => {
    authService.authEvents
      .pipe(
        filter((event) => event === AuthEvent.AUTH_SUCCESSFUL),
        take(1),
      )
      .subscribe({
        next: async () => {
          const portalConfig = await configService.getPortalConfig();
          const ragBackendUrl = portalConfig.portalContext.ragBackendUrl;
          if (!ragBackendUrl) {
            return;
          }
          ragChatService.setBaseUrl(ragBackendUrl);

          const hostElement = document.createElement('div');
          hostElement.id = 'rag-chat-host';
          document.body.appendChild(hostElement);

          const componentRef = createComponent(RagChatComponent, {
            hostElement,
            environmentInjector: injector,
          });
          appRef.attachView(componentRef.hostView);
        },
      });
  };
}
